<script setup lang="ts">
  import { MoreHorizontal, Pencil, Trash2 } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  } from "@/components/ui/dropdown-menu";

  defineProps<{ editable?: boolean }>();

  defineEmits<{ edit: []; remove: [] }>();
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="ghost"
        size="icon-sm"
        class="size-5 text-muted-foreground"
        aria-label="Column actions"
        @click.stop>
        <MoreHorizontal class="size-3.5" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem
        v-if="editable"
        @select="$emit('edit')">
        <Pencil class="size-3.5" />
        Edit recode
      </DropdownMenuItem>
      <DropdownMenuSeparator v-if="editable" />
      <DropdownMenuItem
        class="text-destructive"
        @select="$emit('remove')">
        <Trash2 class="size-3.5" />
        Remove column
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
